import { register } from '../../../JavaScript/Utils'

declare global {
  interface Window {
    YT?: any,
    onYouTubeIframeAPIReady?: any
  }
}

export const YoutubeVideo = (el: HTMLElement) => {
  const videoId = el.dataset.videoId
  const videoWidth = +el.dataset.videoWidth
  const videoHeight = +el.dataset.videoHeight
  const videoContainer: HTMLElement = el.querySelector('.video-container')
  const overlay: HTMLElement = el.querySelector('.overlay')
  const placeholder: HTMLElement = el.querySelector('.placeholder-image')
  const hideControls = el.dataset.hideControls ? true : false
  const autoplay = el.dataset.autoplay ? true : false
  const loop = el.dataset.loop ? true : false

  let initialized = false
  let player: any
  let playerSize = {
    width: 0,
    height: 0
  }

  const calculatePlayerSize = (containerWidth = el.offsetWidth) => {
    const containerWidthDelta = videoWidth - containerWidth
    const videoAspectRatio = videoHeight / videoWidth

    playerSize = {
      width: containerWidth,
      height: videoHeight - containerWidthDelta * videoAspectRatio
    }
  }

  calculatePlayerSize()

  // is this even necessary?
  placeholder.style.width = `${playerSize.width}px`
  placeholder.style.height = `${playerSize.height}px`

  const initApi = () => {
    const YT = window.YT
    el.classList.add('is--loading')
    const initPlayer = () => {
      player = new YT.Player(videoContainer, {
        width: playerSize.width,
        height: playerSize.height,
        videoId: videoId,
        playerVars: {
          autoplay: 1,
          controls: hideControls ? 0 : 1,
          showinfo: 0,
          rel: 0,
          iv_load_policy: hideControls ? 3 : 1,
          modestbranding: 1,
          loop: loop ? 1 : 0,
          mute: autoplay ? 1 : 0
        },
        events: {
          onReady: onPlayerReady,
          onStateChange: onPlayerStateChange
        }
      })

      window.addEventListener('resize', () => {
        calculatePlayerSize()
        player.setSize(playerSize.width, playerSize.height)
      })
    }

    if (typeof YT !== 'undefined' && YT.loaded) {
      initPlayer()
    } else {
      window.onYouTubeIframeAPIReady = () => {
        initPlayer()
      }
    }
  }

  overlay.addEventListener('click', () => {

    if (initialized) {
      player.playVideo()
    } else {
      initApi()
    }
  })

  const onPlayerReady = (event: any) => {
    initialized = true
    player.setPlaybackQuality('highres')
    el.classList.remove('is--mounted')
    el.classList.remove('is--loading')
    el.classList.add('is--playing')
    player.playVideo()
  }

  const onPlayerStateChange = (event: any) => {
    if (initialized && hideControls) {
      if (event.data === YT.PlayerState.PLAYING) {
        el.classList.add('is--playing')
      } else if (event.data === YT.PlayerState.ENDED) {
        player.playVideo()
      } else {
        el.classList.remove('is--playing')
      }
    }
  }

  if (autoplay) {
    initApi()
  }
}

register('YoutubeVideo', YoutubeVideo)
